import "./App.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import { ChakraProvider } from "@chakra-ui/react";
import AddBooking from "./Screens/AddBooking/AddBooking";
import LandingPage from "./Screens/LandingPage/LandingPage";
import UpdateBooking from "./Screens/UpdateBooking/UpdateBooking";
import BookingConfirmed from "./Screens/BookingConfirmed/BookingConfirmed";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});
const App = () => {
  return (
    <ChakraProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/add-booking" element={<AddBooking />} />
            <Route path="/update-booking" element={<UpdateBooking />} />
            <Route path="*" element={<LandingPage />} />
            <Route path="/booking-confirmed" element={<BookingConfirmed />} />
          </Routes>
        </QueryClientProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
};

export default App;
